import ExtractStepperComponent from "../../../../src/pages/apis/pdf-extract/extract-stepper.md";
import WhyExtractAPI from "../../../../src/pages/apis/pdf-extract/why-extract-api.md";
import PdfExtractResourceTitle from "../../../../src/pages/apis/pdf-extract/pdf-extract-resource-title.md";
import ExtractProductCard from "../../../../src/pages/apis/pdf-extract/extract-product.md";
import VisualizerHowItWorks from "../../../../src/pages/apis/pdf-extract/visualizer-how-it-works.md";
import PdfExtractUseCases from "../../../../src/pages/apis/pdf-extract/pdf-extract-resource.md";
import { VisualizerCustomIframeBlock } from "../../../../src/components/visualizerCustomIframe";
import { NewsLetterBlade } from "../../../../src/components/news-letter-blade";
import EsealApiAnnouncement from "../../../../src/pages/apis/e-seal-api-announcement.md";
import * as React from 'react';
export default {
  ExtractStepperComponent,
  WhyExtractAPI,
  PdfExtractResourceTitle,
  ExtractProductCard,
  VisualizerHowItWorks,
  PdfExtractUseCases,
  VisualizerCustomIframeBlock,
  NewsLetterBlade,
  EsealApiAnnouncement,
  React
};